import type { AbsolutePath } from "@ostack.tech/kform";

import { useFormContext } from "./useFormContext.ts";

/**
 * Hook providing access to the current path within the context of a form.
 *
 * @returns The current path within the context of a form.
 * @throws {NoFormContextError} When no form is in context.
 */
export function useCurrentPath(): AbsolutePath {
  return useFormContext().currentPath;
}
